import { takeEvery } from "@redux-saga/core/effects";

import { PagesActionTypes } from "../types";
import { createPageSaga } from "./createPageSaga";
import { deletePageSaga } from "./deletePageSaga";
import { changePageOrderSaga } from "./changePageOrder";
import { UpdatePageSaga } from "./updatePageSaga";
import { UpdatePageDataSaga } from "./updatePageDataSaga";

export default function* pagesSaga() {
    yield takeEvery(PagesActionTypes.CREATE_PAGE_REQUEST, createPageSaga);
    yield takeEvery(PagesActionTypes.DELETE_PAGE_REQUEST, deletePageSaga);
    yield takeEvery(PagesActionTypes.CHANGE_PAGE_ORDER_REQUEST, changePageOrderSaga);
    yield takeEvery(PagesActionTypes.UPDATE_PAGE_REQUEST, UpdatePageSaga);
    yield takeEvery(PagesActionTypes.UPDATE_PAGE_DATA_REQUEST, UpdatePageDataSaga);
}
